import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { LayoutModule } from '../shared/layout/layout.module';
import { AppHeaderComponent } from './app-header.component';
import { TranslateModule } from 'src/modules/base/pipes/translate.module';
import { SecurePipe } from 'src/modules/base/pipes/secure.pipe';
import { CachableSecurePipe } from 'src/modules/base/pipes/cachable-secure.pipe';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    LayoutModule,
    TranslateModule
  ],
  exports: [
    AppHeaderComponent,
    LayoutModule,
    SecurePipe,
    CachableSecurePipe
  ],
  declarations: [
    AppHeaderComponent,
    SecurePipe,
    CachableSecurePipe
  ]
})
export class AppHeaderModule {}
